import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'
import { Grid, Box, Flex } from '@chatterbug/aaron'

// TODOS: update ui StatItem (this local StatItem is outaded)
import StatItem from '../StatItem/StatItem'

import {
  liveLessonIcon,
  flashcardIcon,
  mediaIcon,
  writingIcon,
  timeIcon,
} from './assets'

const AllTimeStatsWidgetBody = ({
  liveLessonCount,
  flashCardCount,
  mediaCount,
  writingCount,
  hoursCount,
}) => {
  return (
    <Box>
      <Flex
        display={{ _: 'flex', tabletWide: 'none' }}
        boxShadow="overlay"
        borderRadius="1x"
        py="4x"
        px={{ _: '2x', mobile: '4x' }}
        overflow="auto"
        flexWrap="wrap"
        flexDirection="column"
        justifyContent="center"
      >
        {/* 2 flex groups to allow for 3 items in first row and 2 in second */}
        <Flex justifyContent="space-around" marginBottom="3x">
          <StatItem
            number={liveLessonCount}
            icon={liveLessonIcon}
            label={t('Live Lessons')}
            divider={false}
          />
          <StatItem
            number={flashCardCount}
            icon={flashcardIcon}
            label={t('Flashcards')}
          />
          <StatItem number={mediaCount} icon={mediaIcon} label={t('Media')} />
        </Flex>
        <Flex justifyContent={{ _: 'center', desktop: 'flex-start' }}>
          <StatItem
            number={writingCount}
            icon={writingIcon}
            label={t('Writing Practice')}
          />
          <StatItem
            number={hoursCount}
            icon={timeIcon}
            label={t('Hours learning')}
          />
        </Flex>
      </Flex>
      {/* same code again, but with grid and without 2 flex groups */}
      <Grid
        boxShadow="overlay"
        borderRadius="1x"
        p="4x"
        pl={42} // figma
        display={{ _: 'none', tabletWide: 'grid' }}
        columns={5}
        gridGap="3x"
      >
        <StatItem
          number={liveLessonCount}
          icon={liveLessonIcon}
          label={t('Live Lessons')}
          divider={false}
        />
        <StatItem
          number={flashCardCount}
          icon={flashcardIcon}
          label={t('Flashcards')}
        />
        <StatItem number={mediaCount} icon={mediaIcon} label={t('Media')} />
        <StatItem
          number={writingCount}
          icon={writingIcon}
          label={t('Writing Practice')}
        />
        <StatItem
          number={hoursCount}
          icon={timeIcon}
          label={t('Hours learning')}
        />
      </Grid>
    </Box>
  )
}

AllTimeStatsWidgetBody.propTypes = {
  liveLessonCount: PropTypes.number.isRequired,
  flashCardCount: PropTypes.number.isRequired,
  mediaCount: PropTypes.number.isRequired,
  writingCount: PropTypes.number.isRequired,
  hoursCount: PropTypes.number.isRequired,
}

AllTimeStatsWidgetBody.propTypes = {}

export default AllTimeStatsWidgetBody
